import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'searchTeamPipe'
})
export class SearchTeamPipe implements PipeTransform {
    transform(value: any, input: string) {
        if (input) {
            input = input.toLowerCase();
            return value.filter(function (el: any) {
                return el.team_name_full.toLowerCase().indexOf(input) > -1;
            });
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/searchTeam/searchTeam.pipe.ts